import cx from 'clsx';
import { IF, Tooltip } from '../../common';
import styles from './status.module.scss';
import { InfoIcon2 } from 'common/all-icons/custom-icons';
import { Flex } from 'antd';

const renderInfoTooltipTitle = ({ description = '', statusName = '' }) => {
  return (
    <Flex vertical gap={4}>
      <div className="body-12-semibold">{statusName}</div>
      <div style={{ color: 'var(--usr-main-text)' }} className="body-12-medium">
        {description}
      </div>
    </Flex>
  );
};

const StatusButton = ({
  status: orignalStatus,
  disposition,
  isTruncate = false,
  truncateLength = 15,
  style = {},
  className = '',
}) => {
  const status = orignalStatus ?? disposition?.status ?? {};
  const description = status?.description;
  const isSameSlug = disposition?.slug && disposition?.slug === status?.slug;
  const statusName = disposition?.name && !isSameSlug ? `${status?.name} - ${disposition?.name}` : status?.name;
  const truncateLimit = description ? truncateLength - 3 : truncateLength;
  const displayTooltip = isTruncate ? statusName?.length > truncateLimit : false;
  const displayName = isTruncate ? statusName?.slice(0, truncateLimit) + '...' : statusName;

  return (
    <Tooltip title={displayTooltip && !description ? statusName : ''}>
      <button
        className={cx(styles.statusButton, className)}
        type="button"
        style={{
          '--bg-color': status?.bg_color,
          backgroundColor: status?.bg_color ?? 'var(--gray-100)',
          color: status?.color ?? 'var(--gray-800)',
          '--color': status?.color ?? 'var(--gray-800)',
          flexShrink: 0,
          wordBreak: 'keep-all',
          ...style,
        }}
      >
        {displayTooltip ? displayName : statusName}
        <IF condition={description}>
          <Tooltip placement="topRight" title={renderInfoTooltipTitle({ description, statusName })}>
            <InfoIcon2 width={16} height={16} />
          </Tooltip>
        </IF>
      </button>
    </Tooltip>
  );
};

export default StatusButton;
